import { render, staticRenderFns } from "./PoiPrices.vue?vue&type=template&id=47bffd4f"
import script from "./PoiPrices.js?vue&type=script&lang=js&external"
export * from "./PoiPrices.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports